import { render, staticRenderFns } from "./WebPartSlickerImage2Designer.vue?vue&type=template&id=38db2952&scoped=true&"
import script from "./WebPartSlickerImage2Designer.vue?vue&type=script&lang=js&"
export * from "./WebPartSlickerImage2Designer.vue?vue&type=script&lang=js&"
import style0 from "./WebPartSlickerImage2Designer.vue?vue&type=style&index=0&id=38db2952&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38db2952",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38db2952')) {
      api.createRecord('38db2952', component.options)
    } else {
      api.reload('38db2952', component.options)
    }
    module.hot.accept("./WebPartSlickerImage2Designer.vue?vue&type=template&id=38db2952&scoped=true&", function () {
      api.rerender('38db2952', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/WebPartSlickerImage2Designer.vue"
export default component.exports